var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 778,
    height: 153,
    viewBox: "0 0 778 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M754.339 3.12928V15.4245H750.945V3.12928H746.251V0.000346184H759.032V3.12928H754.339Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M773.707 15.4241V5.35423L769.365 11.9425H769.278L764.981 5.42103V15.4241H761.631V-4.76837e-06H765.289L769.344 6.52219L773.398 -4.76837e-06H777.055V15.4241H773.707Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7689 107.151C62.8974 116.659 56.8435 120.899 48.1334 120.899C42.9989 120.899 39.0619 119.035 37.3351 115.776C35.3784 112.063 34.4375 107.571 40.1408 83.4019C45.8556 59.1598 48.9774 54.6101 52.7585 50.8347C56.1719 47.4263 61.1526 45.4754 66.4199 45.4754C74.9239 45.4754 78.8768 49.5956 79.2388 58.8273L79.2733 59.7338H114.584L114.647 58.856C115.65 44.9245 112.495 33.9194 105.265 26.1502C98.0526 18.3983 86.9498 14.296 73.1562 14.296C57.9511 14.296 44.3867 19.2818 31.6835 29.5298C14.6417 43.2832 10.3901 61.4785 5.89136 80.7348L4.84191 85.2041C0.285709 104.529 -4.0119 122.781 6.63767 136.683C14.562 147.041 25.8078 152.079 41.0193 152.079C68.6352 152.079 91.7876 135.577 102.953 107.943L103.481 106.635H68.0325L67.7689 107.151Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.731 15.4243L192.321 66.8527H159.259L171.601 15.4243H136.646L104.279 150.947H139.073L151.777 98.0263H184.798L172.031 150.947H206.826L239.686 15.4243H204.731Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.824 101.76H279.173L297.574 70.1793L299.824 101.76ZM296.604 15.423L214.157 150.945H250.742L262.172 131.052H301.866L303.168 150.945H339.471L323.446 15.423H296.604Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M515.073 42.5335L515.234 42.3612L522.039 15.4219H431.249L423.474 46.602H471.73L401.906 124.017L395.187 150.95H487.795L495.667 119.776H445.112L515.073 42.5335Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M599.093 98.2137L607.079 67.035H557.379L562.583 46.6021H620.799L628.792 15.4227H535.551L501.228 150.944H594.026L602.025 119.777H543.964L549.449 98.2137H599.093Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M684.224 71.9177H666.816L673.311 46.7856H691.23C695.023 46.7856 697.973 48.0075 699.757 50.3089C701.49 52.5522 701.988 55.7659 701.122 59.116C699.51 65.3243 693.038 71.9177 684.224 71.9177ZM731.046 28.0918C724.642 19.8069 714.038 15.423 700.371 15.423H646.452L611.589 150.945H646.389L659.243 101.215H668.841L679.612 150.945H719.702L705.185 94.7949C711.817 91.7299 730.213 81.4194 735.905 59.5923C739.032 47.6174 737.26 36.1368 731.046 28.0918Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M362.794 15.2788L351.341 100.193H365.496L358.565 150.956L359.655 150.916L395.752 66.3631H382.738L403.573 15.2788H362.794Z",
    fill: "#7FBC42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.59e248afebfbb2cf0d80166c00cd3662.svg";
export { ForwardRef as ReactComponent };